var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleepInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.74988L16.3638 2.68137C16.7474 2.53153 17 2.16177 17 1.74988C17 1.33799 16.7474 0.96823 16.3638 0.818394L16 1.74988ZM16 22.2501L16.3638 23.1816C16.7474 23.0318 17 22.662 17 22.2501C17 21.8382 16.7474 21.4685 16.3638 21.3186L16 22.2501ZM10 12C10 7.76161 12.6372 4.13671 16.3638 2.68137L15.6362 0.818394C11.1681 2.56333 8 6.91046 8 12H10ZM16.3638 21.3186C12.6372 19.8633 10 16.2384 10 12H8C8 17.0895 11.1681 21.4367 15.6362 23.1816L16.3638 21.3186ZM15.6362 21.3186C14.5106 21.7582 13.2847 22 12 22V24C13.5376 24 15.01 23.7103 16.3638 23.1816L15.6362 21.3186ZM12 22C6.47715 22 2 17.5228 2 12H0C0 18.6274 5.37258 24 12 24V22ZM2 12C2 6.47715 6.47715 2 12 2V0C5.37258 0 0 5.37258 0 12H2ZM12 2C13.2847 2 14.5106 2.24176 15.6362 2.68137L16.3638 0.818394C15.01 0.289696 13.5376 0 12 0V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13V15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5V7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14L17 14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6L20 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepInactive);
export default __webpack_public_path__ + "static/media/sleep-inactive.34d352da621b807c2a76c9695410a495.svg";
export { ForwardRef as ReactComponent };